import { useEffect, useState } from "react";
import { useIsMobile } from "@/hooks/use-mobile";

export function MobileSplashScreen() {
  const [isVisible, setIsVisible] = useState(true);
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) {
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 2000);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isMobile]);

  if (!isVisible || !isMobile) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-gradient-to-br from-primary to-primary-hover flex items-center justify-center">
      <div className="text-center text-white">
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
          <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
            <span className="text-2xl font-bold text-primary">ن</span>
          </div>
        </div>
        
        <h1 className="text-2xl font-bold mb-2">نظام إدارة الشركات السياحية</h1>
        <p className="text-white/80 text-sm">تطبيق حديث ومتطور</p>
        
        <div className="mt-8">
          <div className="w-8 h-8 border-4 border-white/30 border-t-white rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    </div>
  );
}